export default __webpack_public_path__ + "static/media/QK_9510.8804156e.jpg";